// extracted by mini-css-extract-plugin
export default {"contentC":"StageWelcome_contentC__I9Y-9"};